/* ============================================================
   VIADERM — Shopify Theme JavaScript
   ============================================================ */

/* ── Mobile Menu ─────────────────────────────────────────── */
function toggleMobileMenu() {
  const menu = document.getElementById('mobile-menu');
  const overlay = document.getElementById('mobile-menu-overlay');
  const hamburger = document.getElementById('hamburger-btn');
  if (!menu) return;
  const isOpen = menu.classList.toggle('open');
  if (overlay) overlay.classList.toggle('open', isOpen);
  if (hamburger) hamburger.classList.toggle('open', isOpen);
  document.body.style.overflow = isOpen ? 'hidden' : '';
}

function closeMobileMenu() {
  const menu = document.getElementById('mobile-menu');
  const overlay = document.getElementById('mobile-menu-overlay');
  const hamburger = document.getElementById('hamburger-btn');
  if (menu) menu.classList.remove('open');
  if (overlay) overlay.classList.remove('open');
  if (hamburger) hamburger.classList.remove('open');
  document.body.style.overflow = '';
}

/* ── Cart Drawer ─────────────────────────────────────────── */
function openCartDrawer() {
  const drawer = document.getElementById('cart-drawer');
  const overlay = document.getElementById('cart-overlay');
  if (drawer) drawer.classList.add('open');
  if (overlay) overlay.classList.add('open');
  document.body.style.overflow = 'hidden';
  refreshCartDrawer();
}

function closeCartDrawer() {
  const drawer = document.getElementById('cart-drawer');
  const overlay = document.getElementById('cart-overlay');
  if (drawer) drawer.classList.remove('open');
  if (overlay) overlay.classList.remove('open');
  document.body.style.overflow = '';
}

function refreshCartDrawer() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      updateCartCount(cart.item_count);
      updateCartSubtotal(cart.total_price);
      renderCartItems(cart.items);
    })
    .catch(err => console.error('Cart refresh error:', err));
}

function updateCartCount(count) {
  const countEls = document.querySelectorAll('.cart-count');
  countEls.forEach(el => {
    el.textContent = count;
    el.classList.toggle('visible', count > 0);
  });
}

function updateCartSubtotal(totalCents) {
  const subtotalEl = document.getElementById('cart-subtotal');
  if (subtotalEl) {
    subtotalEl.textContent = formatMoney(totalCents);
  }
}

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

function renderCartItems(items) {
  const body = document.getElementById('cart-drawer-body');
  if (!body) return;

  if (!items || items.length === 0) {
    body.innerHTML = '<p class="cart-empty-msg">Your cart is empty.</p>';
    return;
  }

  const html = items.map(item => `
    <div class="cart-item" data-key="${item.key}">
      <img
        class="cart-item__image"
        src="${item.image ? item.image : ''}"
        alt="${item.product_title}"
        onerror="this.style.display='none'"
      >
      <div class="cart-item__details">
        <div class="cart-item__title">${item.product_title}</div>
        ${item.variant_title && item.variant_title !== 'Default Title' ? `<div style="font-size:11px;color:var(--text-muted)">${item.variant_title}</div>` : ''}
        <div class="cart-item__price">${formatMoney(item.line_price)} <span style="color:var(--text-muted);font-size:11px">× ${item.quantity}</span></div>
        <button class="cart-item__remove" onclick="removeCartItem('${item.key}')">Remove</button>
      </div>
    </div>
  `).join('');

  body.innerHTML = html;
}

function removeCartItem(key) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  })
  .then(res => res.json())
  .then(cart => {
    updateCartCount(cart.item_count);
    updateCartSubtotal(cart.total_price);
    renderCartItems(cart.items);
  })
  .catch(err => console.error('Remove item error:', err));
}

/* ── Add to Cart ─────────────────────────────────────────── */
function addToCart(variantId, quantity) {
  quantity = quantity || 1;
  const btn = document.querySelector('.add-to-cart-btn');
  if (btn) {
    btn.textContent = 'Adding...';
    btn.disabled = true;
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: quantity })
  })
  .then(res => res.json())
  .then(() => {
    if (btn) {
      btn.textContent = 'Added!';
      setTimeout(() => {
        btn.textContent = 'Add to Cart';
        btn.disabled = false;
      }, 1500);
    }
    openCartDrawer();
  })
  .catch(err => {
    console.error('Add to cart error:', err);
    if (btn) {
      btn.textContent = 'Add to Cart';
      btn.disabled = false;
    }
  });
}

/* ── Product Form ────────────────────────────────────────── */
function initProductForm() {
  const form = document.getElementById('product-form');
  if (!form) return;

  form.addEventListener('submit', function(e) {
    e.preventDefault();
    const variantInput = form.querySelector('[name="id"]');
    const quantityInput = form.querySelector('[name="quantity"]');
    if (!variantInput) return;
    const variantId = variantInput.value;
    const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
    addToCart(variantId, quantity);
  });
}

/* ── Quantity Selector ───────────────────────────────────── */
function initQuantitySelectors() {
  document.querySelectorAll('.quantity-btn').forEach(btn => {
    btn.addEventListener('click', function() {
      const input = this.parentElement.querySelector('.quantity-input');
      if (!input) return;
      let val = parseInt(input.value) || 1;
      if (this.dataset.action === 'increase') val++;
      if (this.dataset.action === 'decrease') val = Math.max(1, val - 1);
      input.value = val;
    });
  });
}

/* ── Product Image Gallery ───────────────────────────────── */
function initProductGallery() {
  const mainImage = document.getElementById('main-product-image');
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  if (!mainImage || !thumbs.length) return;

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', function() {
      mainImage.src = this.dataset.src || this.src;
      mainImage.srcset = this.dataset.srcset || '';
      thumbs.forEach(t => t.classList.remove('active'));
      this.classList.add('active');
    });
  });
}

/* ── Accordion ───────────────────────────────────────────── */
function initAccordions() {
  document.querySelectorAll('.accordion-trigger').forEach(trigger => {
    trigger.addEventListener('click', function() {
      const body = this.nextElementSibling;
      const isOpen = this.classList.contains('open');

      // Close all in same group
      const group = this.closest('.product-accordion');
      if (group) {
        group.querySelectorAll('.accordion-trigger').forEach(t => {
          t.classList.remove('open');
          const b = t.nextElementSibling;
          if (b) b.classList.remove('open');
        });
      }

      if (!isOpen) {
        this.classList.add('open');
        if (body) body.classList.add('open');
      }
    });
  });
}

/* ── Header Scroll Behavior ──────────────────────────────── */
function initHeaderScroll() {
  const announcementBar = document.getElementById('announcement-bar');
  const header = document.querySelector('.site-header');
  if (!header) return;

  window.addEventListener('scroll', function() {
    if (!announcementBar || announcementBar.style.display === 'none') {
      header.classList.add('no-announcement');
    }
  }, { passive: true });
}

/* ── Smooth Scroll ───────────────────────────────────────── */
function initSmoothScroll() {
  document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', function(e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
}

/* ── Cart Page Quantity ──────────────────────────────────── */
function updateLineItemQuantity(key, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: parseInt(quantity) })
  })
  .then(res => res.json())
  .then(cart => {
    updateCartCount(cart.item_count);
    // Reload cart page to reflect changes
    window.location.reload();
  })
  .catch(err => console.error('Update quantity error:', err));
}

/* ── Init ────────────────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', function() {
  initProductForm();
  initQuantitySelectors();
  initProductGallery();
  initAccordions();
  initHeaderScroll();
  initSmoothScroll();

  // Initial cart count
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => updateCartCount(cart.item_count))
    .catch(() => {});
});